import { updateObject } from "../../../../shared";
import { globalConstants, managerPerformanceConstants } from "../../constants";

const { SUCCESS, FAILURE } = globalConstants;
const {
  ALL_MANAGER_RESPONSE_DATA,
  CUSTOMER_RESPONSES_EXPORT_ALL_DATA,
  STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING,
} = managerPerformanceConstants;

const initialState = {
  allItemsForExport: [],
  managerResponsesData: [],
  allManagerResponseData: [],
  managerResponseDataPagination: {
    size: 10,
    number: 0,
    totalElements: 0,
  },
  storesAvgSentimentAndTransactionRatingData: {},
};

export const managerPerformanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_MANAGER_RESPONSE_DATA + SUCCESS:
      return updateObject(state, {
        allManagerResponseData: action.data.pageData,
        managerResponsesData: action.data.pageData.result,
        managerResponseDataPagination: action.data.page,
      });
    case CUSTOMER_RESPONSES_EXPORT_ALL_DATA + SUCCESS:
      return updateObject(state, {
        allItemsForExport: action.data,
      });
    case CUSTOMER_RESPONSES_EXPORT_ALL_DATA + FAILURE:
      return updateObject(state, { allItemsForExport: [] });
    case STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING + SUCCESS:
      return updateObject(state, {
        storesAvgSentimentAndTransactionRatingData: action.data,
      });
    default:
      return state;
  }
};
